/**
 * API v1 for FLEXI web portal
 * A sample description of FLEXI API version 1 for web portal.
 *
 * OpenAPI spec version: 1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type ContractType = 'ElectricityLowVoltage' | 'ElectricityHighVoltage' | 'GasSmallConsumption' | 'GasLargeConsumption' | 'HeatSmallConsumption';

export const ContractType = {
    ElectricityLowVoltage: 'ElectricityLowVoltage' as ContractType,
    ElectricityHighVoltage: 'ElectricityHighVoltage' as ContractType,
    GasSmallConsumption: 'GasSmallConsumption' as ContractType,
    GasLargeConsumption: 'GasLargeConsumption' as ContractType,
    HeatSmallConsumption: 'HeatSmallConsumption' as ContractType
};